import { createSlice } from '@reduxjs/toolkit';
import { initialState } from './initialState';
import { resetAllStores, setPlanoAtual } from '../sharedActions';
import {
  alteraPlano,
  getDadosPessoais,
  getMensageria,
  getPaginasDisponiveisExtrato,
  getPendenciasUsuario,
  login,
  loginADM,
} from './thunks';

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    editAtualizacaoCadastral: (state, action) => {
      state.alteracaoDadosPessoais.editMode = action.payload;
      state.alteracaoDadosPessoais.data = [];
    },
    saveAtualizacaoCadastral: (state, action) => {
      const findSameType = state.alteracaoDadosPessoais.data.findIndex(
        (item) => item.type === action.payload.type
      );

      if (findSameType !== -1) {
        state.alteracaoDadosPessoais.data.splice(
          findSameType,
          1,
          action.payload
        );
      } else {
        state.alteracaoDadosPessoais.data.push(action.payload);
      }
    },
    resetUser: (state) => {
      state.isLogged = false;
      state.error = initialState.error;
      state.data = initialState.data;
      state.dadosPessoais = initialState.dadosPessoais;
      state.alteracaoDadosPessoais = initialState.alteracaoDadosPessoais;
      state.extrato = initialState.extrato;
    },
    logout: (state) => {
      state.isLogged = false;
    },
    restoreSession: (state, action) => {
      state.isLogged = true;
      state.data.matricula = action.payload.matricula;
      state.data.token = action.payload.token;
      if (action.payload.plano) {
        state.data.plano = action.payload.plano;
      }
    },
    marcarMensagemLida: (state, action) => {
      const idMsg = action.payload;
      state.mensageria = (state.mensageria || []).map((msg) =>
        msg.idMsg === idMsg && msg.Lida === null
          ? { ...msg, Lida: new Date().toISOString() }
          : msg
      );
      state.mensagensPendentes = state.mensageria.some(
        (msg) => msg.Lida === null
      );
    },
  },
  extraReducers(builder) {
    builder.addCase(resetAllStores, () => initialState);

    builder.addCase(setPlanoAtual, (state, action) => {
      state.data.plano = action.payload;
    });

    builder.addCase(login.pending, (state, action) => {
      state.isLoading = true;
      state.error = '';
      state.data.matricula = action.meta.arg.matricula;
    });

    builder.addCase(login.fulfilled, (state, { payload }) => {
      state.data.token = payload.token;

      state.isLoading = false;
      state.isLogged = payload.success;
    });

    builder.addCase(login.rejected, (state, action) => {
      const { payload } = action;

      state.error = payload || 'Erro inesperado. Tente novamente mais tarde.';
      state.isLoading = false;
    });

    builder.addCase(loginADM.fulfilled, (state, { payload }) => {
      state.data.matricula = payload.matricula;
      state.data.token = payload.token;
      state.isLogged = true;
      state.isLoading = false;
    });

    builder.addCase(loginADM.rejected, (state, action) => {
      state.error =
        action.payload || 'Erro ao simular usuário. Tente novamente.';
      state.isLoading = false;
    });

    builder.addCase(getDadosPessoais.pending, (state) => {
      state.error = '';
      state.isLoading = true;
    });

    builder.addCase(getDadosPessoais.fulfilled, (state, action) => {
      const { data, planoID, dadosSAPNaoTratados } = action.payload;

      state.dadosPessoais = data;
      state.dadosSAPNaoTratados = dadosSAPNaoTratados;
      state.data.plano = planoID;

      // SecureStore.setItemAsync(
      //   'Forluz-username',
      //   JSON.stringify({
      //     name: state.dadosPessoais.nome,
      //     matricula: state.data.matricula,
      //   })
      // );

      state.isLoading = false;
    });

    builder.addCase(getDadosPessoais.rejected, (state) => {
      state.isLoading = false;
    });

    builder.addCase(alteraPlano.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(alteraPlano.fulfilled, (state, action) => {
      state.isLoading = false;

      state.data.plano = action.payload.plano?.id.toString() || '3';
    });

    builder.addCase(getPendenciasUsuario.fulfilled, (state, action) => {
      state.pendencias = {
        TermoConsentimento: action.payload.TermoConsentimento,
        AtualizacaoCadastral: action.payload.AtualizacaoCadastral,
      };
    });

    builder.addCase(getMensageria.fulfilled, (state, action) => {
      state.mensageria = action.payload.mensageria;
      state.mensagensPendentes = action.payload.mensagensPendentes;
    });

    builder.addCase(getPaginasDisponiveisExtrato.fulfilled, (state, action) => {
      const { pages, plano, cnpb } = action.payload;
      const habilitar = (pages || []).reduce(
        (prev, curr) => {
          if (
            initialState.extrato.habilitar[curr.Identificador] !== undefined
          ) {
            return { ...prev, [curr.Identificador]: curr.Visibilidade };
          }
          return prev;
        },
        { ...initialState.extrato.habilitar }
      );
      state.extrato = {
        ...state.extrato,
        plano: plano ?? state.extrato.plano,
        cnpb: cnpb ?? state.extrato.cnpb,
        habilitar,
      };
    });
  },
});

export const user = userSlice.reducer;
export const {
  editAtualizacaoCadastral,
  saveAtualizacaoCadastral,
  resetUser,
  logout,
  restoreSession,
  marcarMensagemLida,
} = userSlice.actions;
